import axios, { InternalAxiosRequestConfig } from 'axios';
import { getApiBaseUrl } from './api-base-url';

const LOCALHOST_API_URL_RE = /^https?:\/\/(localhost|127\.0\.0\.1):3001/i;

const isLoopbackHost = (host: string): boolean => host === 'localhost' || host === '127.0.0.1';

let installed = false;

export const installAxiosApiUrlGuard = (): void => {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const rawUrl = typeof config.url === 'string' ? config.url : '';
    if (!rawUrl || !LOCALHOST_API_URL_RE.test(rawUrl)) return config;

    if (isLoopbackHost(window.location.hostname)) return config;

    const targetApiBase = getApiBaseUrl();
    config.url = rawUrl.replace(LOCALHOST_API_URL_RE, targetApiBase);
    return config;
  });
};
